module.exports = __webpack_public_path__ + "img/iphone-1.7a264323.jpg";